module.exports = __webpack_public_path__ + "af3deac7e9390ab907c5cdc552bdc3b8.png";